import React, { useState, useEffect, useRef } from 'react';
import { Globe, ChevronDown, Check } from 'lucide-react';

const OPTIONS = [
  { code: '',   label: 'Auto' },
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'Arabic' },
  { code: 'es', label: 'Spanish' },
  { code: 'zh', label: 'Chinese' },
  { code: 'hi', label: 'Hindi' },
];

export default function LanguageControl({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const active = OPTIONS.find(o => o.code === (value || '')) || OPTIONS[0];

  return (
    <div className="mic-control" ref={containerRef}>
      <button
        className={`mic-pill${open ? ' mic-pill--open' : ''}`}
        onClick={() => !disabled && setOpen(o => !o)}
        disabled={disabled}
        title="Transcription language"
        type="button"
      >
        <Globe size={13} color="#6b7280" />
        <span style={{ fontWeight: 500 }}>{active.label}</span>
        <ChevronDown size={13} className={`mic-pill__chevron${open ? ' mic-pill__chevron--up' : ''}`} />
      </button>

      {open && (
        <div className="mic-dropdown">
          <div className="mic-dropdown__header">Language</div>
          {disabled && (
            <div className="mic-dropdown__notice">Stop recording to change language</div>
          )}
          <ul className="mic-dropdown__list">
            {OPTIONS.map(opt => {
              const isActive = (value || '') === opt.code;
              return (
                <li key={opt.code || 'auto'}>
                  <button
                    className={`mic-dropdown__item${isActive ? ' mic-dropdown__item--active' : ''}`}
                    onClick={() => {
                      if (!disabled) {
                        onChange(opt.code);
                        setOpen(false);
                      }
                    }}
                    disabled={disabled}
                    type="button"
                  >
                    <Check size={13} className="mic-dropdown__check" style={{ opacity: isActive ? 1 : 0 }} />
                    <span>{opt.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
